import { Grid, Text, Title } from "@mantine/core";
import {
  ScatterChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Scatter,
  ResponsiveContainer,
} from "recharts";
import { PDFPage } from "./PDFPage";
import useReportStore from "../../../store/useReportStore";

import { useTranslation } from "react-i18next";
import { getCurrencySymbol } from "../../../utils/helpers";

const scaleValue = (
  value: number,
  min: number,
  max: number,
  newMin: number,
  newMax: number
) => {
  return ((value - min) / (max - min)) * (newMax - newMin) + newMin;
};

// Масив кольорів
const COLORS = [
  "rgba(5, 216, 210, 0.6)",
  "rgba(166, 77, 215, 0.6)",
  "rgba(111, 64, 226, 0.6)",
  "rgba(58, 139, 217, 0.6)",
];

const CustomBubble = (props: any) => {
  const { cx, cy, payload } = props;
  const rawRadius = payload.x;
  const minRadius = 36;
  const radius = rawRadius < minRadius ? minRadius : rawRadius;
  const lines = payload.label.split(" ");

  return (
    <>
      <text
        x={cx + radius + 5}
        y={cy - 10}
        fill="#000"
        fontSize="20px"
        fontWeight="bold"
        textAnchor="start"
      >
        {lines.map((line: string, index: number) => (
          <tspan key={index} x={cx + radius + 5} dy={index === 0 ? "0" : "27"}>
            {line}
          </tspan>
        ))}
      </text>
      <circle cx={cx} cy={cy} r={radius} fill={payload.color} />
      <text
        x={cx}
        y={cy}
        fill="#fff"
        fontSize="28px"
        fontWeight="bold"
        textAnchor="middle"
        dominantBaseline="middle"
      >
        {payload.value}
      </text>
    </>
  );
};

export const OptimalPositionsPDF = () => {
  const { report } = useReportStore();
  const { t } = useTranslation();

  const min = -10;
  const max = 115;
  const newMin = 0;
  const newMax = 100;

  const positions = report?.optimal_positions_switch?.mark_down
    ? report.optimal_positions_switch
    : report?.optimal_positions?.mark_down
    ? report.optimal_positions
    : null;

  const data = positions?.data.map((role, index) => ({
    x: scaleValue(role.fit_percentage, min, max, newMin, newMax),
    y: scaleValue(role.job_stability, min, max, newMin, newMax),
    label: role.title,
    value: role.average_salary,
    color: COLORS[index % COLORS.length],
  }));

  return (
    <PDFPage padding>
      <Title size={48} mb={8}>
        {positions?.mark_down ? positions?.mark_down.replace(/^## /, "") : ""}
      </Title>
      <Text mb={48} size="28px" lh="42px" c="dimmed">
        {positions?.explanation ? positions?.explanation : ""}
      </Text>
      <Text fw="bold" size="20px" mb={10}>
        {t("job_stability")} %
      </Text>
      <ResponsiveContainer height={680} width="100%">
        <ScatterChart>
          <CartesianGrid />
          <XAxis type="number" dataKey="x" name="X-axis" domain={[0, 100]} />
          <YAxis type="number" dataKey="y" name="Y-axis" domain={[0, 100]} />
          <Tooltip cursor={{ strokeDasharray: "3 3" }} />
          <Scatter name="Positions" data={data} shape={CustomBubble} />
        </ScatterChart>
      </ResponsiveContainer>
      <Text fw="bold" size="20px" ta="right">
        {t("match")} %
      </Text>
      <Grid>
        {positions?.data.map((position, index) => (
          <Grid.Col span={6} key={index}>
            <Text fw="bold" size="26px" lh="38px" mt={10}>
              {position.title}
            </Text>
            <Text size="18px" lh="26px">
              <b>{t("average_salary")}</b>:{" "}
              {getCurrencySymbol(position?.salary_currency) || "$"}
              {position.average_salary.toLocaleString()}
            </Text>
            <Text size="18px" lh="26px">
              {position.description}
            </Text>
          </Grid.Col>
        ))}
      </Grid>
    </PDFPage>
  );
};
